import useModuleInfo from "./useModuleInfo";

function useSubscription() {
  const chaserModuleInfo = useModuleInfo();

  return {
    ...chaserModuleInfo,
    subscription: { ...chaserModuleInfo.module },
  };
}

export default useSubscription;
